import '../style/tabs-fjWqhcIG.css'
import { computed as d, defineComponent as L, openBlock as m, createBlock as p, unref as a, normalizeClass as S, withCtx as v, mergeProps as $, createCommentVNode as I, renderSlot as h, createTextVNode as K, toDisplayString as U, normalizeProps as Q, withModifiers as W, ref as g, createElementBlock as E, Fragment as X, renderList as Y, withDirectives as ee, createSlots as te, resolveDynamicComponent as R, createElementVNode as j, createVNode as w, useSlots as se, toRef as ie, watch as x, normalizeStyle as ae, Transition as N } from "vue";
import "@vueuse/core";
import { TABS_PROVIDER as G } from "./constant/providers.js";
import { CHANGE_EVENT as H, UPDATE_MODEL_VALUE as M, REMOVE_CHILD_EVENT as oe } from "./constant/events.js";
import { useChildContext as ne, useParentContext as le } from "./hooks/useFamily.js";
import { useKeyboardNavigation as re } from "./hooks/useKeyboardNavigation.js";
import { useBorderBoxElementSize as ue } from "./hooks/useBorderBoxElementSize.js";
import { useScrollContainer as ce } from "./hooks/useScrollContainer.js";
import O from "./internalComponents/ScrollArrow.js";
import me from "./directives/ripple.js";
import { DEFAULT_RIPPLE_SETTING as de } from "./constant/ripple.js";
import fe from "./badge.js";
import pe from "./link.js";
import F from "./icon.js";
import ve from "./internalComponents/CrossIcon.js";
import { getIcon as P } from "./utils/icon.js";
import { isLinkActive as be } from "./utils/link.js";
import Ie, { MenuList as he } from "./menu.js";
import { DEFAULT_SIZE as _e } from "./constant/common.js";
const ye = (u, i, s) => {
  const l = typeof u, n = typeof s;
  if (l === "string") {
    const e = u;
    return {
      text: e,
      value: n === l ? e : i
    };
  } else {
    const e = u, r = e.value ?? e.to ?? i;
    return {
      ...e,
      value: r
    };
  }
};
function ke(u, i) {
  const s = d(() => u.value.map((e, r) => ye(e, r, i))), l = d(() => s.value.filter((e) => !e.isMenu)), n = d(() => s.value.filter((e) => e.isMenu));
  return {
    tabItems: s,
    normalItems: l,
    menuItems: n
  };
}
function we(u, i, s) {
  const { childValue: l, context: n } = ne({ providerKey: G, value: u });
  if (!n)
    throw new Error("TabItem can not be used without Tabs");
  const e = d(() => i ? be(l, n.activeValue.value) : l === n.activeValue.value);
  return {
    classList: d(() => {
      const o = ["e-tabs__item"];
      return e.value && o.push("e-tabs__item--active"), s && o.push("e-tabs__item--closable"), o;
    }),
    handleItemClick: (o) => {
      n.scrollIntoView?.(o.currentTarget), n.setActiveValue(l), n.emit?.(H, l);
    },
    handleItemClose: () => {
      n.removeChild(l);
    },
    active: e
  };
}
const Ce = /* @__PURE__ */ L({
  name: "e-tab-item",
  __name: "tab-item",
  props: {
    active: { type: Boolean },
    text: {},
    badge: {},
    value: {},
    closable: { type: Boolean },
    to: {},
    prefixIcon: {},
    suffixIcon: {},
    headerId: {},
    panelId: {}
  },
  setup(u) {
    const i = u, s = i.to !== void 0, { classList: l, handleItemClick: n, handleItemClose: e, active: r } = we(i.value, s, i.closable), b = P(i.suffixIcon), t = P(i.prefixIcon);
    return (o, V) => (m(), p(a(pe), {
      id: o.headerId,
      "a11y-attrs": {
        role: "tab",
        tabindex: a(r) ? 0 : -1,
        "aria-controls": o.panelId,
        "aria-selected": a(r) ? "true" : "false"
      },
      class: S(a(l)),
      to: o.to,
      onClick: a(n)
    }, {
      default: v(() => [
        a(t) ? (m(), p(a(F), $({
          key: 0,
          class: "mr-8",
          size: "16"
        }, a(t)), null, 16)) : I("", !0),
        o.text ? h(o.$slots, "item", { key: 1 }, () => [
          K(U(o.text) + " ", 1),
          o.badge ? (m(), p(a(fe), Q($({ key: 0 }, o.badge)), null, 16)) : I("", !0)
        ]) : I("", !0),
        h(o.$slots, "default"),
        a(b) ? (m(), p(a(F), $({
          key: 2,
          class: "ml-8",
          size: "16"
        }, a(b)), null, 16)) : I("", !0),
        o.closable ? (m(), p(ve, {
          key: 3,
          class: "e-tabs__item-close",
          onClick: W(a(e), ["stop"])
        }, null, 8, ["onClick"])) : I("", !0)
      ]),
      _: 3
    }, 8, ["id", "a11y-attrs", "class", "to", "onClick"]));
  }
}), ge = /* @__PURE__ */ L({
  name: "e-tab-items",
  __name: "tab-items",
  props: {
    tabItems: {},
    ripple: { type: [Boolean, Object] },
    isFitted: { type: Boolean },
    isDelimited: { type: Boolean },
    variant: { default: "default" },
    activeItemValue: {},
    itemSlot: {}
  },
  setup(u, { expose: i }) {
    const s = u, l = g(), n = d(() => ["e-tabs__items"]), e = d(() => {
      switch (s.variant) {
        case "default":
        case "pill":
          return de;
        case "button":
          return { background: "var(--bg-status-plain)" };
        case "plain":
        case "folder":
          return { background: "var(--bg-status-plain-bold)" };
        default:
          return !0;
      }
    });
    return i({
      tabItemsRef: l
    }), (r, b) => (m(), E("div", {
      ref_key: "tabItemsRef",
      ref: l,
      class: S(n.value),
      role: "tablist",
      "aria-orientation": "horizontal"
    }, [
      (m(!0), E(X, null, Y(r.tabItems, (t, o) => ee((m(), p(Ce, {
        key: t.value,
        "header-id": t.headerId,
        "panel-id": t.panelId,
        text: t.text,
        badge: t.badge,
        value: t.value,
        closable: t.closable,
        to: t.to,
        "prefix-icon": t.prefixIcon,
        "suffix-icon": t.suffixIcon
      }, te({
        default: v(() => [
          t.component ? (m(), p(R(t.component), {
            key: 0,
            item: t,
            index: o
          }, null, 8, ["item", "index"])) : I("", !0)
        ]),
        _: 2
      }, [
        r.itemSlot ? {
          name: "item",
          fn: v(() => [
            (m(), p(R(r.itemSlot), {
              item: t,
              index: o
            }, null, 8, ["item", "index"]))
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["header-id", "panel-id", "text", "badge", "value", "closable", "to", "prefix-icon", "suffix-icon"])), [
        [a(me), e.value]
      ])), 128)),
      h(r.$slots, "menu")
    ], 2));
  }
}), Ve = { class: "e-tabs__menu" }, ze = ["tabIndex"], $e = /* @__PURE__ */ L({
  __name: "tab-menu",
  props: {
    tabIndex: {},
    activeValue: {},
    menuItems: {},
    size: {},
    setActiveValue: { type: Function }
  },
  setup(u) {
    const i = u, s = g(!1), l = d(() => ({
      rotation: s.value ? 180 : 0,
      size: "16",
      icon: "caret-down"
    })), n = g(i.menuItems[0]), e = d(() => i.menuItems.find((_) => _.value === i.activeValue)), r = d(() => e.value || n.value), b = d(() => ["e-tabs__menu--selected", "e-tabs__item", { "e-tabs__item--active": !!e.value }]), t = (f) => {
      const { index: y } = f, _ = i.menuItems[y];
      n.value = _, i.setActiveValue(_.value);
    }, o = () => {
      i.setActiveValue(r.value.value);
    }, V = () => {
    };
    return (f, y) => (m(), E("div", Ve, [
      j("div", {
        class: S(b.value),
        role: "tab",
        tabIndex: e.value ? 0 : -1,
        onClick: o,
        onKeydown: V
      }, [
        h(f.$slots, "default", { item: r.value }, () => [
          K(U(r.value.text), 1)
        ])
      ], 42, ze),
      h(f.$slots, "middle", { item: r.value }),
      w(a(Ie), {
        open: s.value,
        "onUpdate:open": y[0] || (y[0] = (_) => s.value = _),
        placement: "bottom-end",
        "trigger-arrow": "",
        "trigger-arrow-icon": "caret-down",
        "offset-distance": 2,
        "render-trigger-button": !1,
        "trigger-by-hover": !1,
        "auto-select": !1,
        size: f.size,
        onSelect: t
      }, {
        content: v(() => [
          w(a(he), {
            items: f.menuItems,
            size: f.size
          }, null, 8, ["items", "size"])
        ]),
        default: v(() => [
          w(a(F), $({ class: "arrow-icon" }, l.value), null, 16)
        ]),
        _: 1
      }, 8, ["open", "size"])
    ]));
  }
});
function Ee(u) {
  const { slots: i, isDelimited: s, isFitted: l, variant: n, size: e } = u, r = d(() => !!i.left || !!i.right || u.isFlex);
  return {
    tabsClassList: d(() => {
      const t = ["e-tabs"];
      return r.value && t.push("e-tabs--is-flex"), l && t.push("e-tabs--is-fitted"), s && t.push("e-tabs--delimited"), e && e !== _e && t.push(`e-tabs--${e}`), n && t.push(`e-tabs-${n}`), t;
    })
  };
}
const qe = /* @__PURE__ */ L({
  name: "e-tabs",
  __name: "tabs",
  props: {
    modelValue: {},
    items: { default: () => [] },
    ripple: { type: [Boolean, Object] },
    isFlex: { type: Boolean },
    isFitted: { type: Boolean },
    isDelimited: { type: Boolean },
    variant: { default: "default" },
    size: { default: "sm" },
    overrides: {},
    showScrollArrows: { type: Boolean },
    menuSize: {}
  },
  emits: [M, H, oe],
  setup(u, { emit: i }) {
    const s = u, l = i, n = se(), e = g(), r = ie(s, "items"), { width: b } = ue(e), { normalItems: t, menuItems: o, tabItems: V } = ke(r, s.modelValue), {
      containerRef: f,
      showLeftArrow: y,
      showRightArrow: _,
      handleArrowClick: B,
      scrollIntoView: T
    } = ce({
      showScrollArrows: s.showScrollArrows
    }), { tabsClassList: Z } = Ee({
      slots: n,
      variant: s.variant,
      isFlex: s.isFlex,
      isDelimited: s.isDelimited,
      isFitted: s.isFitted,
      size: s.size
    }), q = {
      providerKey: G,
      allowMultiple: !1,
      defaultValue: s.modelValue,
      scrollIntoView: T,
      emit: l
    }, { context: k } = le(q);
    x(b, () => {
      T(k.activeElement.value);
    });
    const D = d(() => k.activeValue.value), J = d(() => V.value.findIndex((c) => c.value === D.value));
    x(k.activeValue, (c) => {
      l(M, c), setTimeout(() => {
        T(k.activeElement.value);
      });
    }), x(
      () => s.modelValue,
      (c) => {
        k.setActiveValue(c);
      }
    );
    const A = g(!1);
    return re({
      watchSource: A,
      wrapperRef: f,
      selector: ".e-tabs__item",
      clickImmediate: !0,
      initIndex: J
    }), (c, z) => (m(), E("div", {
      ref_key: "wrapperRef",
      ref: e,
      class: S(a(Z)),
      style: ae(c.overrides)
    }, [
      h(c.$slots, "left"),
      w(N, { name: "fade" }, {
        default: v(() => [
          a(y) ? (m(), p(O, {
            key: 0,
            type: "left",
            onClick: a(B)
          }, null, 8, ["onClick"])) : I("", !0)
        ]),
        _: 1
      }),
      j("div", {
        ref_key: "containerRef",
        ref: f,
        class: "e-tabs__items-container e-scroller--none",
        onFocusin: z[0] || (z[0] = (C) => A.value = !0),
        onFocusout: z[1] || (z[1] = (C) => A.value = !1)
      }, [
        w(ge, {
          "tab-items": a(t),
          ripple: c.ripple,
          "is-fitted": c.isFitted,
          "is-delimited": c.isDelimited,
          variant: c.variant,
          "item-slot": c.$slots.item
        }, {
          menu: v(() => [
            a(o).length > 0 ? (m(), p($e, {
              key: 0,
              "menu-items": a(o),
              "active-value": D.value,
              "set-active-value": a(k).setActiveValue,
              size: c.menuSize
            }, {
              default: v(({ item: C }) => [
                h(c.$slots, "tab-menu-left", { item: C })
              ]),
              middle: v(({ item: C }) => [
                h(c.$slots, "tab-menu-middle", { item: C })
              ]),
              _: 3
            }, 8, ["menu-items", "active-value", "set-active-value", "size"])) : I("", !0)
          ]),
          _: 3
        }, 8, ["tab-items", "ripple", "is-fitted", "is-delimited", "variant", "item-slot"])
      ], 544),
      w(N, { name: "fade" }, {
        default: v(() => [
          a(_) ? (m(), p(O, {
            key: 0,
            type: "right",
            onClick: a(B)
          }, null, 8, ["onClick"])) : I("", !0)
        ]),
        _: 1
      }),
      h(c.$slots, "right")
    ], 6));
  }
});
export {
  Ce as TabItem,
  qe as Tabs
};
//# sourceMappingURL=tabs.js.map
